<template>
  <div id="app" :class="this.moblie ? 'bodyBg' : ''" style="width: 100%">
    <div>
      <div>
        <!-- 保存当前状态，不会销毁组件 -->
        <!-- <keep-alive :exclude="RouterPath"> -->
          <router-view />
        <!-- </keep-alive> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from "vuex";
export default {
  name: "App",
  data() {
    return {
      // 获取当前屏幕宽度
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      //获取当前屏幕高度
     windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      //当前路径的url
      path: "",
      //在Vuex里面获取数据
      DepsDat: this.$store.state.DepsDat,
      RouterPath:'',
    };
  },
  computed: {
    // Vuex的mapGetters里面获取数据
    ...mapGetters(["moblie", "indexRow"]),
    ...mapState(["moblie", "indexRow"]),
  },
  mounted() {
    // 实时获取浏览器宽度高度
    let that = this;
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
        if (this.windowWidth >= 768) {
          this.SET_MOBLIE(true);
        } else {
          this.SET_MOBLIE(false);
        }
      })();
    }
  },
  created() {
    //页面加载判断屏幕的宽度
    if (this.windowWidth >= 768) {
      this.SET_MOBLIE(true);
    } else {
      this.SET_MOBLIE(false);
    }

    this.RouterPath = this.$route
    //如果屏幕的宽度大于等于768，则使用moblie为true,反之取反
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("messageStore", JSON.stringify(this.$store.state));
      localStorage.setItem('',"")
    });
    // 在页面加载时读取sessionStorage里的状态信息
    sessionStorage.getItem("messageStore") &&
      this.$store.replaceState(
        Object.assign(
          this.$store.state,
          JSON.parse(sessionStorage.getItem("messageStore"))
        )
      );
       localStorage.setItem('',"")
      //获取用户点击进来的url,对url进行解析，并获取Vuex里面的下标数据
    let index = window.location.hash;

    index = index.split("/");
    if (index.length == 2) {
      var a = index[1];
      a = a.split(".");
      a = a[0];
      this.path = a;
      // 找到url对应数据的下标
      this.DepsDat.map((item, index) => {
        for (var i = 0; i < item.children.length; i++) {
          if (item.children[i].picName == this.path) {
            var data = {
              a: index,
              b: i,
            };
            // 修改clickCid的值
            this.SET_CLICKCID(data);
          }
        }
      });
    } else {
    };



  },
  methods: {
    //利用map方法的形式添加或更改Vuex里面的数据
    ...mapMutations({
      SET_MOBLIE: "SET_MOBLIE",
      SET_INDEXROW: "SET_INDEXROW",
      SET_CLICKCID:'SET_CLICKCID'
    }),
  },
};
</script>
<style >
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.bodyBg {
  background: url(./assets/img/index/topbg.png) no-repeat center 0;
}
a {
  cursor: pointer;
}
div::selection {
  background-color: aliceblue;
  /* color: #ff9900; */
  color: #137ccd;
}
p::selection {
  background-color: aliceblue;
  /* color: #ff9900; */
  color: #137ccd;
}
li::selection {
  background-color: aliceblue;
  /* color: #ff9900; */
  color: #137ccd;
}
span::selection {
  background-color: aliceblue;
  /* color: #ff9900; */
  color: #137ccd;
}
a::selection {
  background-color: aliceblue;
  /* color: #ff9900; */
  color: #137ccd;
}
</style>
